/** @jsxImportSource @emotion/react */

import React from 'react';
import { v4 as uuid4 } from 'uuid';
import styled from 'styled-components';
import * as size from '@constant/size';
import * as color from '@constant/color';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { useCategoriesQuery } from '@hook/moashelf/useApi';
import { ICategoryData } from '@datatype/moashelf/api-type';
import TextBlock from '@component/common/block/text-block';
import { IS_IYAGIGO_MOBILE_VIEW } from '@config/environment';
import { actions as newsletterActions } from '@store/slice/newsletter-slice';

const Wrapper = styled.div``;

const CATEGORY_ITEM_WIDTH = '70px';
const CATEGORY_GAP_WIDTH = '10px';

const MobileCategoryContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;
  width: calc(4 * ${CATEGORY_ITEM_WIDTH} + 3 * ${CATEGORY_GAP_WIDTH});
  gap: ${CATEGORY_GAP_WIDTH};
  margin: ${size.MARGIN_2} auto 0 auto;
`;

const WebCategoryContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: ${CATEGORY_GAP_WIDTH};
  margin: ${size.MARGIN_2} 0 0 0;
`;

const BeginCategory: React.FC<any> = () => {
  const dispatch = useTypedDispatch();
  const categoryKey = useTypedSelector((state) => state.rootReducer?.newsletterReducer?.categoryKey) || null;
  const categoriesQuery = useCategoriesQuery(1, 10);

  const categories = (categoriesQuery.data?.data || []) as ICategoryData[];
  const categoriesWithAll = [{ name: '전체', key: null, code: null }, ...categories];

  const Categories = categoriesWithAll.map((category) => {
    const isSelected = category.key === categoryKey;

    return (
      <TextBlock
        key={uuid4()}
        text={category.name}
        design={{
          text: { size: 'medium', color: isSelected ? color.WHITE_1 : color.GRAY_1 },
          box: {
            borderWidth: '1px',
            borderColor: isSelected ? color.BLACK_2 : color.GRAY_1,
            borderRadius: size.BORDER_RADIUS_2,
            width: '70px',
            padding: '2px 0 2px 0',
            backgroundColor: isSelected ? color.BLACK_2 : 'transparent',
            event: { cursor: 'pointer' },
          },
        }}
        click={{ handler: () => dispatch(newsletterActions.clickCategory(category.key)) }}
      />
    );
  });

  return (
    <Wrapper>
      {IS_IYAGIGO_MOBILE_VIEW ? (
        <MobileCategoryContainer>{Categories}</MobileCategoryContainer>
      ) : (
        <WebCategoryContainer>{Categories}</WebCategoryContainer>
      )}
    </Wrapper>
  );
};

export default BeginCategory;
